import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetMappingName = urlConfig.GetMappingName;
const EditMetaDataMapping = urlConfig.GetMetadataMappingEdit;
const AddMetadataMapping = urlConfig.GetMetadataMappingConfiguartion;
const MetadatamappingInsert = urlConfig.MetadatamappingInsert;

export const getMetaDataMapping = async (params: any) => {
  try {
    const response = await postCall(GetMappingName, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const editMetaDataMapping = async (params: any) => {
  try {
    const response = await postCall(EditMetaDataMapping, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const addMetadataMapping = async (params: any) => {
  try {
    const response = await postCall(AddMetadataMapping, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const createMetadataMapping = async (params: any) => {
  try {
    const response = await postCall(MetadatamappingInsert, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
